import { z } from "zod";

import type { ImpulseFormList, ImpulseFormShape } from "~/tools/impulse-form";

import { partial, tuple } from "./_decoders";
import { Encoder } from "./_encoder";
import { FormState as QueryFormState } from "./query";
import { FormState as SettingsFormState } from "./settings";

type FormState = ImpulseFormShape<{
	queries: ImpulseFormList<QueryFormState>;
	settings: SettingsFormState;
}>;

const decoder = tuple([
	z.array(QueryFormState.decoder).optional().catch(undefined),

	SettingsFormState.decoder,
])
	.transform(([queries, settings]) => partial({ queries, settings }))
	.catch(undefined);

function encoder(state: z.infer<typeof decoder>): Encoder {
	return Encoder.tuple(
		Encoder.list(state?.queries, [{ promql: "", alias: "", minStep: "" }], QueryFormState.encoder),
		SettingsFormState.encoder(state?.settings),
	);
}

const FormState = { decoder, encoder };

export { FormState };
